(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ef-collection-guide')) {
    customElements.define('ef-collection-guide', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(min-width:750px)');
        this.update = () => { this.querySelector('details').open = this.breakpoint.matches; };
        this.update();
        this.breakpoint.addEventListener('change', this.update);
      }
      disconnectedCallback() { this.breakpoint.removeEventListener('change', this.update); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-order-popup"]) return;
  try {
    
  if(!customElements.get('first-order-popup'))customElements.define('first-order-popup',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-open]');if(!this.dialog?.showModal)return;
      this.key='ef-first-order-offer-dismissed';this.trigger.hidden=false;
      this.trigger.addEventListener('click',()=>this.open());this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{try{localStorage.setItem(this.key,String(Date.now()));}catch{}this.trigger.hidden=false;this.trigger.focus({preventScroll:true});});
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      let dismissed=false;try{dismissed=Date.now()-Number(localStorage.getItem(this.key)||0)<30*86400000;}catch{}
      if(!dismissed&&!matchMedia('(max-width:749px)').matches)this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open]'))this.open();},Number(this.dataset.delay)||18000);
    }
    open(){this.dialog.showModal();this.trigger.hidden=true;this.querySelector('[data-close]').focus();}
    disconnectedCallback(){clearTimeout(this.timer);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interior-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interior-hero')) {
    customElements.define('interior-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.current = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.visible = false;
        this.interval = Number(this.dataset.interval) || 6000;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.toggle = this.querySelector('[data-action=toggle]');
        if (this.slides.length < 2) return;
        this.querySelector('.ef-interior-hero__controls').hidden = false;
        this.addEventListener('pointerdown', event => { if (event.target.closest('[data-action=toggle]')) this.toggleWasPaused = this.paused; }, options);
        this.addEventListener('click', event => {
          const action = event.target.closest('[data-action]')?.dataset.action;
          if (!action) return;
          if (action === 'toggle') { this.paused = !(this.toggleWasPaused ?? this.paused); this.toggleWasPaused = undefined; }
          else { this.paused = true; this.show(this.current + (action === 'next' ? 1 : -1)); }
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
        this.addEventListener('shopify:block:select', event => { const selected = this.slides.findIndex(slide => slide.contains(event.target)); if (selected >= 0) { this.paused = true; this.show(selected); this.schedule(); } }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold:0.1});
        this.observer.observe(this);
        this.schedule();
      }
      show(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
          if (active) { const img = slide.querySelector('img'); if (img) img.loading = 'eager'; }
        });
        this.querySelector('[data-current]').textContent = String(this.current + 1);
      }
      schedule() {
        clearTimeout(this.timer);
        this.dataset.paused = String(this.paused);
        if (this.toggle) this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        if (!this.paused && !this.hovered && this.visible && !document.hidden && this.slides.length > 1) this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, this.interval);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ef-brand-autoplay')) {
    customElements.define('ef-brand-autoplay', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('ul');
        this.toggle = this.querySelector('button');
        if (!this.list || !this.toggle) return;
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.visible = false;
        this.resumeAt = 0;
        this.addEventListener('pointerdown', () => { this.resumeAt = Date.now() + 8000; }, options);
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.setAttribute('aria-label', this.paused ? 'Play automatic brand slideshow' : 'Pause automatic brand slideshow');
          this.toggle.querySelector('path').setAttribute('d', this.paused ? 'M5 3l7 5-7 5Z' : 'M5 3v10M11 3v10');
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold: 0.2});
        this.observer.observe(this);
        this.timer = setInterval(() => {
          if (!this.mobile.matches || this.reduced.matches || !this.visible || document.hidden || this.paused || Date.now() < this.resumeAt || this.contains(document.activeElement)) return;
          const first = this.list.firstElementChild;
          const second = first?.nextElementSibling;
          if (!second) return;
          const step = second.offsetLeft - first.offsetLeft;
          const max = this.list.scrollWidth - this.list.clientWidth;
          this.list.scrollTo({left: this.list.scrollLeft >= max - 2 ? 0 : Math.min(max, this.list.scrollLeft + step), behavior: 'smooth'});
        }, 3000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-inquiry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-consultation')) customElements.define('product-consultation', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.contactForm = this.querySelector('form');
    this.handleChange = event => {
      const form = event.target.closest('form');
      if (form && form !== this.contactForm && form.querySelector('[name="id"]') && form.action.includes('/cart/add')) this.activeProductForm = form;
    };
    this.handleClick = event => {
      if (!event.target.closest('[data-product-consultation]')) return;
      this.syncSelection();
      requestAnimationFrame(() => this.contactForm.querySelector('[name="contact[name]"]').focus({preventScroll:true}));
    };
    this.handleSubmit = () => this.syncSelection();
    document.addEventListener('input', this.handleChange);
    document.addEventListener('change', this.handleChange);
    document.addEventListener('click', this.handleClick);
    this.contactForm.addEventListener('submit', this.handleSubmit);
    this.syncSelection();
  }
  syncSelection() {
    const form = this.activeProductForm?.isConnected ? this.activeProductForm : document.querySelector('[data-choice-form], [data-configuration-purchase], .ef-product-purchase__form, form[action*="/cart/add"]');
    const lines = [];
    if (form) {
      const properties = new FormData(form);
      for (const [key, value] of properties) {
        if (key.startsWith('properties[') && String(value).trim()) lines.push(key.slice(11,-1) + ': ' + value);
      }
      const selector = form.closest('catalog-configuration-order')?.querySelector('[data-configuration-selector]');
      selector?.querySelectorAll('select').forEach(select => {
        const label = selector.querySelector('label[for="' + select.id + '"]')?.textContent.trim();
        const chosen = select.selectedOptions[0]?.textContent.trim();
        if (chosen && select.value) lines.push((label || 'Option') + ': ' + chosen);
      });
      const variantLabel = form.getAttribute('aria-label');
      if (variantLabel) lines.unshift('Variant: ' + variantLabel);
      this.querySelector('[data-inquiry-variant]').value = properties.get('id') || '';
      this.querySelector('[data-inquiry-quantity]').value = properties.get('quantity') || '1';
      lines.push('Quantity: ' + (properties.get('quantity') || '1'));
    }
    this.querySelector('[data-inquiry-configuration]').value = lines.length ? [...new Set(lines)].join('\n') : 'Options not selected yet — help requested.';
  }
  disconnectedCallback() {
    document.removeEventListener('input', this.handleChange);
    document.removeEventListener('change', this.handleChange);
    document.removeEventListener('click', this.handleClick);
    this.contactForm?.removeEventListener('submit', this.handleSubmit);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-offer"]) return;
  try {
    
  if(!customElements.get('welcome-offer'))customElements.define('welcome-offer',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>this.connectedCallback(),{once:true});return;}
      this.ready=true;this.dialog=this.querySelector('dialog');if(!this.dialog||!this.dialog.showModal)return;
      this.teaser=this.querySelector('[data-offer-open]');this.form=this.querySelector('form');this.key='ef-welcome5-dismissed';this.success=!!this.querySelector('[data-offer-success]');
      this.teaser.addEventListener('click',()=>this.open());this.querySelector('[data-offer-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.dialog.addEventListener('close',()=>{try{localStorage.setItem(this.key,String(Date.now()));}catch{}this.teaser.hidden=this.success;});
      this.form.addEventListener('submit',()=>{const b=this.querySelector('[data-submit]');if(b){b.disabled=true;b.textContent=b.dataset.sending;}});
      let dismissed=false;try{dismissed=Date.now()-Number(localStorage.getItem(this.key)||0)<30*86400000;}catch{}
      if(this.success){try{localStorage.setItem(this.key,String(Date.now()));}catch{}this.open();}
      else if(this.querySelector('[data-offer-error]')||this.hasAttribute('data-preview'))this.open();
      else{this.teaser.hidden=false;if(!dismissed&&!matchMedia('(max-width:600px)').matches)this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open]'))this.open();},Number(this.dataset.delay)||18000);}
    }
    open(){this.dialog.showModal();this.teaser.hidden=true;this.querySelector('[data-offer-success],input[type=email]')?.focus();}
    disconnectedCallback(){clearTimeout(this.timer);}
  });

  } catch(e) { console.error(e); }
})();
})();
